import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import OfficeBMOTable from "./view/OfficeBMOTable";

export const OfficeBMO = () => {
  const viewBMO =
    PERMISSIONS.permission_utilities_officeconfiguration_officebmo_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <>{userPermissions.includes(viewBMO) && <OfficeBMOTable />}</>;
};

export default OfficeBMO;
